import { GetterTree } from 'vuex'
import { State } from '../../store'
import ComponentState from './states'
import { getMenu } from '@/services/Menus'

const getters: GetterTree<ComponentState, State> = {
  snackBarLists: (state) => {
    return state.snackbar
  },
  titlePage: (state) => {
    return state.titlePage
  },
  menuSidebar: (state) => {
    return getMenu()
  },
  pageLoading: (state) => {
    return state.pageLoading
  },
  ready: (state) => {
    return state.ready
  },
  level: (state) => {
    return state.user.level
  },
  prefixNames: () => {
    return [
      'นาย',
      'นาง',
      'นางสาว',
      'เด็กหญิง',
      'เด็กชาย',
    ]
  },
  banks: (state) => {
    return [
      {name: 'promptpay', text: 'พร้อมเพย์'},
      {name: 'baac', text: 'ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร (ธกส.)'},
      {name: 'bay', text: 'ธนาคารกรุงศรีอยุธยา'},
      {name: 'bbl', text: 'ธนาคารกรุงเทพ'},
      {name: 'ktb', text: 'ธนาคารกรุงไทย'},
      {name: 'kbank', text: 'ธนาคารกสิกรไทย'},
      {name: 'scb', text: 'ธนาคารไทยพาณิชย์'},
      {name: 'ttb', text: 'ธนาคารทหารไทยธนชาต'},
    ]
  },
}

export default getters
